export default "__VITE_ASSET__ChvNphix__"